import logInDev from './logger';

export const SEGMENT_BLOCKED_MESSAGE = `Segment blocked ${Date.now()}`;

const segmentBlocked = () => window.analytics.blockedStatus === true;

const getAnalytics = () => window.analytics;

const segmentReady = () => typeof getAnalytics().user().anonymousId() === 'string';

const exponentialBackoff = async (toTry, max = 7, delay = 100) => {
  if (segmentBlocked()) {
    throw new Error('Segment script blocked');
  }
  return new Promise((resolve, reject) => {
    if (toTry()) {
      resolve();
    } else if (max > 0) {
      setTimeout(() => {
        resolve(exponentialBackoff(toTry, max - 1, delay * 2));
      }, delay);
    } else {
      window.analytics.blockedStatus = true;
      reject();
    }
  });
};

export const waitForSegment = async () => {
  return exponentialBackoff(segmentReady)
    .then(() => getAnalytics())
    .catch(() => {
      logInDev('Analytics did not load');
      return false;
    });
};

export const convertAnonymousUser = async () => {
  const analytics = await waitForSegment();
  if (analytics) {
    const segmentId = analytics.user().anonymousId();
    analytics.identify(segmentId);
    return segmentId;
  }
  return SEGMENT_BLOCKED_MESSAGE;
};

export const getSegmentId = async () => {
  const analytics = await waitForSegment();
  if (analytics) {
    return analytics.user().id() ?? convertAnonymousUser();
  }
  return SEGMENT_BLOCKED_MESSAGE;
};
